// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import "react-toastify/dist/ReactToastify.css";

// import App from "./App";
// import reportWebVitals from "./reportWebVitals";

// import { ToastContainer } from "react-toastify";

// const root = ReactDOM.createRoot(document.getElementById("root"));

// // root.render(
// //   <React.StrictMode>
// //     <App />
// //     <ToastContainer />
// //   </React.StrictMode>,
// // );

// root.render(
//   <>
//     <App />
//     <ToastContainer />
//   </>,
// );

// reportWebVitals();

import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n/i18n";
import App from "./App";
import { LoaderProvider } from "./context/LoaderContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <LoaderProvider>
    <App />
  </LoaderProvider>,
);
